import { Entity } from "@dinahmoe/dmafjs-core";

class ScrollProxy extends Entity {
  namespace = "se26:scrollProxy";
}

const scrollProxy = new ScrollProxy();
export { scrollProxy, ScrollProxy };
